import React from "react";

const Nested_Loops = () => {
  return (
    <div>
      <h1>Nested_Loops Component</h1>
      <p>Content for Nested_Loops goes here...</p>
    </div>
  );
};

export default Nested_Loops;
